export const getCalculatorAddressData = (data) => ({
  addressLine1: data.addressLine1,
  addressLine2: data.addressLine2,
  city: data.city,
  country: data.countryCode ?? data.stateOrProvince?.country?.code,
  stateProvinceCode: data.stateProvinceCode ?? data.stateOrProvince?.code,
  zipCode: data.postalCode ?? data.zipCode,
});

export const getBuyLabelAddressData = (data) => ({
  addressLine1: data.addressLine1,
  addressLine2: data.addressLine2,
  city: data.city,
  countryCode: data.countryCode ?? data.stateOrProvince?.country?.code,
  stateProvinceCode: data.stateProvinceCode ?? data.stateOrProvince?.code,
  zipCode: data.postalCode ?? data.zipCode,
});

export const getValidatorAddressData = (data) => ({
  addressLine1: data.addressLine1,
  addressLine2: data.addressLine2,
  city: data.city,
  countryCode: data.countryCode ?? data.stateOrProvince?.country?.code,
  stateProvinceCode: data.stateProvinceCode ?? data.stateOrProvince?.code,
  postalCode: data.postalCode ?? data.zipCode,
});

export const getAddressDataFromSuggestion = (data) => ({
  addressLine1: data.addressLine1,
  addressLine2: data.addressLine2,
  city: data.city,
  countryCode: data.countryCode ?? data.stateOrProvince?.country?.code,
  stateProvinceCode: data.stateProvinceCode ?? data.stateOrProvince?.code,
  zipCode: data.postalCode ?? data.zipCode,
});

const transientAddressIds = new Set(['manual', 'duplicate']);

export const isTransientAddressId = (id) =>
  !!id && (id.startsWith('geo-') || transientAddressIds.has(id));

export const getSavedAddressId = (id) => (isTransientAddressId(id) ? null : id);
